// extracted by mini-css-extract-plugin
module.exports = {"cls1":"styleHelpers-flexColumn_cls1__3R1dk","cls2":"styleHelpers-flexColumn_cls2__1kcir styleHelpers-flexColumn_cls1__3R1dk"};